import { ORDER_STATE_N2 } from "../../../config/constants";

/**
 * Cuándo el "Imprimir" de Nave 2 (punteo y botones de los listados) debe arrancar la
 * preparación. Sin dependencias HTTP a propósito: InfoOrder lo importa y sus tests no
 * pueden cargar axios (ver CLAUDE.md, "El automock revienta").
 */

/**
 * Indica si imprimir la etiqueta de un pedido debe ponerlo en preparación.
 * DECISION: solo si está sin preparar. En el punteo el botón desaparece cuando el pedido
 * está completo, pero el listado también muestra pedidos en revisión o preparados, y uno
 * ya en preparación puede reimprimirse: volver a imprimir su etiqueta no debe devolverlo a
 * "en preparación" ni cambiar su preparador.
 */
export const debeIniciarPreparacion = (estado) => !estado || String(estado) === ORDER_STATE_N2.SIN_PREPARAR;

/**
 * Indica si imprimir la etiqueta de un grupo debe asignarle preparador y ponerlo en preparación.
 * DECISION: solo si está PENDIENTE. Un grupo EN_PROCESO ya tiene quien lo prepara: reimprimir
 * su etiqueta no debe cambiarle el preparador por el usuario conectado.
 */
export const debeIniciarPreparacionGrupo = (estado) => !estado || estado === 'PENDIENTE';
